import React, { useState } from "react";

const DEFAULT_IMAGE = "https://cdn-icons-png.flaticon.com/512/847/847969.png";

const MembersAvatars = ({ members }) => {
  const [hoveredMember, setHoveredMember] = useState(null);
  const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });

  const styles = {
    container: {
      display: "flex",
      alignItems: "center",
      position: "relative",
    },
    avatar: {
      width: "32px",
      height: "32px",
      borderRadius: "50%",
      border: "2px solid #1c1c1c",
      objectFit: "cover",
      marginLeft: "-8px",
      backgroundColor: "#ccc",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "#fff",
      fontSize: "14px",
      fontWeight: "bold",
      cursor: "pointer",
    },
    firstAvatar: {
      marginLeft: "0px",
    },
    tooltip: {
      position: "fixed",
      backgroundColor: "#1e1e1e",
      color: "#fff",
      padding: "8px 12px",
      borderRadius: "6px",
      fontSize: "12px",
      fontWeight: "500",
      zIndex: 10000,
      pointerEvents: "none",
      boxShadow: "0 4px 8px rgba(0,0,0,0.3)",
      border: "1px solid #314158",
      maxWidth: "200px",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
  };

  const maxVisible = 3;
  const extraCount = members.length - maxVisible;

  const handleMouseEnter = (member, event) => {
    setHoveredMember(member);
    const rect = event.currentTarget.getBoundingClientRect();
    setTooltipPosition({
      x: rect.left + rect.width / 2,
      y: rect.top - 10,
    });
  };

  const handleMouseLeave = () => {
    setHoveredMember(null);
  };

  return (
    <div style={styles.container}>
      {members.slice(0, maxVisible).map((member, index) => (
        <img
          key={index}
          src={DEFAULT_IMAGE}
          alt={member.name || "Member"}
          style={{
            ...styles.avatar,
            ...(index === 0 ? styles.firstAvatar : {}),
          }}
          onMouseEnter={(e) => handleMouseEnter(member, e)}
          onMouseLeave={handleMouseLeave}
        />
      ))}

      {members.length > maxVisible && (
        <div
          style={{
            ...styles.avatar,
            backgroundColor: "#555",
          }}
          onMouseEnter={(e) => handleMouseEnter({ name: `+${extraCount} outros membros` }, e)}
          onMouseLeave={handleMouseLeave}
        >
          +{extraCount}
        </div>
      )}

      {hoveredMember && (
        <div
          style={{
            ...styles.tooltip,
            left: tooltipPosition.x,
            top: tooltipPosition.y,
            transform: "translateY(-30%)",
          }}
        >
          {hoveredMember.name}
        </div>
      )}
    </div>
  );
};

export default MembersAvatars;